module.exports = __webpack_public_path__ + "static/img/wrong-icon.843347e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wrong-icon.png
// module id = 870
// module chunks = 2 3 4 5